import React from "react";

//my coode
import { useState } from "react";

function usePagination(data, itemsPerPage) {
    const [currentPage, setCurrentPage] = useState(1);
    const maxPage = Math.ceil(data?.length / itemsPerPage) + 1;

    function next() {
        setCurrentPage((currentPage) => currentPage + 1);
    }

    function prev() {
        setCurrentPage((currentPage) => currentPage - 1);
    }

    function jump(page) {
        const pageNumber = Math.max(1, page);
        setCurrentPage(pageNumber);
    }

    return { next, prev, jump, currentPage };
}

export default usePagination;
